/**
 * Created by Qingger Corp.
 * User: 陈儒
 * Date: 2019/12/30
 * Time: 11:01
 * Desc:
 */
import { Component, Vue } from "vue-property-decorator";
import VueQArt from "vue-qart";
import { IPSService } from "@/services/ipsServices";
import { downloadIamge, QinggerLibUtils } from "@/util";
import NoAuth from "@/views/components/noAuth/noAuth.vue";
import { globalElement } from "@/library/utils/globalElement";
import { EmpServiceAPIActions } from "@/services/empService";
import baseAPIService from "@/services/base/baseAPIService";
import { Functions } from "@/library/utils/functions";
import { appEnvConfig } from "@/configs/appConfigs";
import Timer = NodeJS.Timer;

@Component({
	components: {
		NoAuth,
		VueQArt,
	},
})
export default class wActivityTemplate extends Vue {
	// @Prop({default: []}) siteArr : ItemArray<OrgSiteTreeNodeInfo>;
	/// @Prop({default: {}}) actType : ActType;

	/* 店铺多级选择器字段对应设置 */
	public theProps: object = {
		value: "code",
		label: "name",
		children: "children",
	};

	/* 选中的活动 */
	public multipleSelection: Array<any> = [];

	/**
	 * corpId
	 */
	public corpId = baseAPIService.resolveCorpId();

	/* 是否选中活动 */
	public isSelected = false;

	/* 分 */
	public Minute = 0;
	/* 秒 */
	public Second = 0;

	/* 定时器 */
	public timer: Timer = null;

	/* 是否显示二维码 */
	public isShowCode = false;

	/* 是否显示网点组 */
	public isShowSite = false;

	/**
	 * 选择的网点
	 * @type {any[]}
	 */
	public siteValue: ItemArray<any> = [];

	/**
	 * checkBox选中列表
	 * @type {any}
	 */
	public checkSiteList = [];

	/**
	 * 网点组列表(API)
	 * @type {Array}
	 */
	public sitesGroupArray: ItemArray<SiteGroupInfo> = [];

	/* 列表请求参数 */
	public requestParam: ActivityRequestParam = { actStatus: 9 };

	public isShowEnroll = false;
	/* 活动列表  api */
	public activityList: ItemArray<ActivityInfo> = null;
	public listCount = 0;
	public page = 1;
	public pageNum = 10;

	public loadingState = true;

	/* 活动状态 */
	public activityStatus: Array<any> = [
		{
			value: 9,
			label: "全部",
		},
		{
			value: 0,
			label: "未开始",
		},
		{
			value: 1,
			label: "进行中",
		},
		{
			value: 2,
			label: "已过期",
		},
	];

	// 表格高度
	public cpHeight = 0;

	public imageUrl = "https://ssl-picture.tenyun.runsasoft.com/Fp3EHKcpqhwZS6Z-mSgfKRfGePT_";

	public tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	/* 图片上传地址 */
	public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	public crmActInfo: {
		cadId?: number;
		actPicture?: string;
		actJoinConfig?: {
			joinTitle?: string;
			joinButton?: string;
			joinPicture?: string;
		};
		actSgList?: Array<{
			sgId?: number;
			sgName?: string;
			isDefault?: number;
		}>;
		isDisplay?: number;
		isOrder?: boolean;
	} = null;

	// 当前选择的网点
	public selectValue: any = null;

	public actQcode = "";

	public thisCadId = 0;

	public switchValue = false;

	public selectMode = "";

	/**
	 * 内容是否显示
	 * @type {boolean}
	 */
	public isContentBodyShow = false;

	created() {
		// 权限检测
		this.isContentBodyShow = this.$store.state.authMenuCodeList.includes("VSHOP-FUNCTION-ACTIVITY-OUT");
		if (this.isContentBodyShow) {
			this.requestParam.page = this.page;
			this.requestParam.pageNum = this.pageNum;
			this.getActivityList();
			this.cpHeight = window.screen.availHeight - 385;
			this.getSiteGroupList();
		}
	}

	public mounted() {
		const self = this;
		// 屏幕尺寸改变时触发
		window.onresize = function () {
			self.cpHeight = window.screen.availHeight - 385;
		};
	}

	/**
	 * 获取活动列表
	 */
	public getActivityList(): void {
		this.activityList = [];
		const queryParams = this.requestParam;
		IPSService.getCrmActList({ queryParams }).then((responseData: any) => {
			this.loadingState = false;
			this.listCount = responseData.count;
			if (responseData.count > 0) {
				this.activityList = responseData.list;
				this.loadingState = false;
			}
		});
	}

	/**
	 * 表格当前页
	 * @param val
	 */
	handleCurrentChange(val) {
		this.page = val;
		this.requestParam.page = val;
		this.getActivityList();
	}

	/**
	 * 每页显示条数
	 * @param val
	 */
	selectedPageNum(val) {
		this.requestParam.pageNum = val;
		this.requestParam.page = 1;
		this.page = 1;
		this.getActivityList();
	}

	/**
	 * 清除报名列表搜索记录
	 */
	clearEnData() {
		this.isShowEnroll = false;
	}

	/**
	 * 当前输入的留言关键字
	 * @param value
	 */
	getEnrollWord(value) {}

	/**
	 * 留言输入框失去焦点事件
	 */
	inputEnrollBlur() {}

	/**
	 * 清除定时器
	 */
	closeTimer() {
		/* clearInterval(this.timer); */
		this.isShowSite = false;
	}

	/**
	 * 当前选择的活动状态
	 */
	selectStatus(value) {
		this.requestParam.actStatus = value;
		this.requestParam.page = 1;
		this.page = 1;
		this.getActivityList();
	}

	/**
	 *
	 */
	editWAct(actId) {
		const self = this;
		IPSService.getCrmActInfo({ queryParams: { cadId: actId } }).then((res: any) => {
			self.crmActInfo = Object.assign({}, res, { isOrder: !!res.isOrder });
			self.checkSiteList = self.crmActInfo.actSgList.map((item) => {
				// return Object.assign({},item, {isDefault:1});

				return item.sgId;
			});
			self.switchValue = !!self.crmActInfo.isDisplay;
			self.isShowEnroll = !self.isShowEnroll;
		});
	}

	/**
	 * A13.获取外部活动详情(查看列表中的网点组列表也用这个)
	 */
	getCrmActInfo(actId) {
		const self = this;
		self.crmActInfo = {};
		IPSService.getCrmActInfo({ queryParams: { cadId: actId } }).then((res: any) => {
			self.crmActInfo = Object.assign({}, res, { isOrder: !!res.isOrder });
			self.switchValue = !!self.crmActInfo.isDisplay;
			self.isShowSite = !self.isShowSite;
		});
	}

	/**
	 * 获得网点组列表(API)
	 * @api :
	 */
	public getSiteGroupList(): void {
		IPSService.getSiteGroupList().then((responseData) => {
			this.loadingState = false;
			if (responseData.count) {
				// this.sitesGroupArray = responseData.list;
				this.sitesGroupArray = responseData.list.map((item) => {
					return {
						sgId: item.sgId,
						sgName: item.sgName,
						isDefault: 0,
					};
				});
				if (responseData.count < 1) {
					globalElement.message.warning("未检索到网点组");
				}
			}
		});
	}

	handleCheckedChange(value) {
		console.log(this.checkSiteList);
	}

	/**
	 * 图片上传之前的格式验证
	 * @param file
	 * @returns {boolean}
	 */
	beforeAvatarUpload(file) {
		console.debug(file);
		const isJPG = file.type === "image/jpeg";
		const isPNG = file.type === "image/png";
		const isGIF = file.type === "image/gif";
		const isLt1000KB = file.size / 1024 < 1000;
		if (!isJPG && !isPNG && !isGIF) {
			globalElement.message.error("上传图片只支持 JPG/JPEG/PNG/GIF 格式!");
		}
		if (!isLt1000KB) {
			globalElement.message.error("上传图片大小不能超过 500KB!");
		}
		return (isJPG || isPNG || isGIF) && isLt1000KB;
	}

	/**
	 * 图片上传成功时的处理
	 * @param res
	 * @param file
	 */
	handleAvatarSuccess(res: HttpAPIRetItem<any>, file: any) {
		this.crmActInfo.actPicture = res.content;
	}

	/**
	 * 上传失败提示
	 * @param err
	 */
	uploadError(err) {
		const result = JSON.parse(err.message);
		if (result.message) {
			this.$message.error(result.message);
		}
	}

	/**
	 * 图片上传成功时的处理
	 * @param res
	 * @param file
	 */
	handlePicSuccess(res: HttpAPIRetItem<any>, file: any) {
		this.crmActInfo.actJoinConfig.joinPicture = res.content;
	}

	submitAct() {
		const self = this;
		this.crmActInfo.actSgList = this.checkSiteList;
		// this.crmActInfo.isOrder = Number(this.crmActInfo.isOrder);
		const postParams = this.crmActInfo;
		IPSService.postCrmActSave({
			postParams: Object.assign({}, postParams, { isOrder: Number(this.crmActInfo.isOrder) }),
		}).then((res) => {
			globalElement.message.success("操作成功");
			self.isShowEnroll = false;
			self.getActivityList();
		});
	}

	updateCrmAct() {
		const self = this;
		IPSService.updateCrmAct().then((res) => {
			self.page = 1;
			self.requestParam.page = 1;
			self.getActivityList();
		});
	}

	downQcode(id) {
		const self = this;
		IPSService.getCrmActInfo({ queryParams: { cadId: id } }).then((res: any) => {
			self.crmActInfo = Object.assign({}, res);
			self.isShowCode = !self.isShowCode;
			self.thisCadId = id;
			self.getQcode();
		});
	}

	getQcode(val?) {
		const self = this;
		self.selectValue = val || self.crmActInfo.actSgList[0];
		IPSService.GetCrmActQrcode({
			postParams: {
				cadId: self.thisCadId,
				sgId: this.selectValue.sgId,
			},
		}).then((res: any) => {
			self.actQcode = res.actUrl || "../../../../static/img/default-goods.png";
		});
	}

	clickGuiderSelect() {}

	switchChange(value) {
		this.crmActInfo.isDisplay = Number(value);
	}

	/*
	 **活动下架
	 */
	stopAct(cid) {
		const self = this;
		IPSService.updateCrmActState({ postParams: { cadId: cid, actState: 0 } }).then((responseData) => {
			if (responseData) {
				globalElement.message.success("操作成功");
				self.page = 1;
				self.requestParam.page = 1;
				self.getActivityList();
			} else {
				globalElement.message.error("操作失败");
			}
		});
	}

	/**
	 * 输入框失去焦点事件
	 */
	inputWordBlur() {
		this.page = 1;
		this.requestParam.page = 1;
		this.getActivityList();
	}

	/**
	 * 输入的活动关键字
	 */
	getInputWord(value) {
		this.requestParam.keyWords = value;
	}

	downLoad() {
		downloadIamge(this.actQcode, "Qcode");
	}
}
